<div class="user-container">
	<button type="button" class="btn btn-primary w-100 p-2" (click)="openInviteUser()">
		<i class="bi bi-person-plus"></i>
		Invite New User
	</button>

	<ul class="list-group">
		<ng-container *ngFor="let member of organisationMembers">
			<li
				class="list-group-item text-primary"
				role="button"
				tabindex="0"
				(click)="openEditUser(member)"
				(keydown.enter)="openEditUser(member)"
				(keydown.space)="openEditUser(member)"
			>
				<div class="list-item d-flex">
					<div class="left-side">
						<div class="fw-bold">{{ member.user.displayName ?? member.user.email }}</div>
						<div>{{ member.organisationUser.accessLevel | titlecase }}</div>
					</div>
					<div>
						<span class="badge rounded-pill" [ngClass]="organisationStatusBackground(member)">{{
							member.organisationUser.status | titlecase
						}}</span>
					</div>
				</div>
			</li>
		</ng-container>
	</ul>
</div>
